import type { RootState } from '@/app/providers/store';
import { useSelector } from 'react-redux';

export const useAuth = () => {
  const { isAuth, accessToken, loading, error, status } = useSelector(
    (state: RootState) => state.auth,
  );
  return {
    status,
    isAuth,
    accessToken,
    loading,
    error,
  };
};
